/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import MIKE_COLORS from "../../styles/mike-colors"
import mikeSharedTheme from "../../styles/mikeSharedTheme"

export const contentWrapStyle = {
    height: '450px',
    minWidth: '720px',
    margin: '8px 16px',
    backgroundColor: MIKE_COLORS.XLIGHTGREY,
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: MIKE_COLORS.MEDIUMGREY_DEFAULT,
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: MIKE_COLORS.DARKGREY_DEFAULT,
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: MIKE_COLORS.BRANDBLUE_DEFAULT,
    },
  }



  export const contentStyle = {
    height: 'max-content'
  }
  export const scrollDivStyle = {
    overflowY: 'auto',
    height: '25vh',
    margin: '1rem 0 0 0',
    padding: mikeSharedTheme.spacing(1)
  }

  export const scrollPaperStyle = {
    backgroundColor: MIKE_COLORS.XLIGHTGREY
  }

  export const hidePanelStyle = {
    display: 'none'
  }

  export const dialogBottomStyle = {
    boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.16)',
    backgroundColor: 'white',
    zIndex: 99
  }



  export const rootStyle = {
      margin: 0,
      padding: '20px 32px',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.16)',
      fontSize: '20px',
      zIndex: 99,
      backgroundColor: 'white'
    }

   export const closeButtonStyle = css`
      position: absolute;
      right: 3px;
      top: 3px;
      cursor: pointer;
      & svg {
        width: 32px;
        height: 32px;
      };
      & svg path {
        transform: translate(-4px, -4px);
      };
      &:hover svg {
        background-color: ${MIKE_COLORS.MEDIUMGREY_LIGHT};
        border-radius: 32px;
      };
   `;

